const Logo = ({ height = 52 }) => (
  <span className="logo-wrap" style={{ height }}>
    <img src="/logo-white.png" alt="Raddish Media" className="logo-theme logo-theme--white" />
    <img src="/logo-dark.png"  alt="Raddish Media" className="logo-theme logo-theme--dark" />
  </span>
);

export default Logo;
